module.exports = __webpack_public_path__ + "static/netflix-tudum-2-a2c014db8850f051345618318ded036a.jpg";